"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSplits = void 0;
var constants_1 = require("../../logger/constants");
var lang_1 = require("../lang");
var split_1 = require("./split");
function validateSplits(log, maybeSplits, method, listName, item) {
    if (listName === void 0) { listName = 'feature flag names'; }
    if (item === void 0) { item = 'feature flag name'; }
    if (Array.isArray(maybeSplits) && maybeSplits.length > 0) {
        var validatedArray_1 = [];
        // Remove invalid values
        maybeSplits.forEach(function (maybeSplit) {
            var splitName = (0, split_1.validateSplit)(log, maybeSplit, method, item);
            if (splitName)
                validatedArray_1.push(splitName);
        });
        // Strip off duplicated values if we have valid split names then return
        if (validatedArray_1.length)
            return (0, lang_1.uniq)(validatedArray_1);
    }
    log.error(constants_1.ERROR_EMPTY_ARRAY, [method, listName]);
    return false;
}
exports.validateSplits = validateSplits;
